import { connect, ConnectedProps } from 'react-redux';

import lang from '../../../lib/language';
import { ReportingCall } from '../../../lib/models/reporting/types';
import { RootState } from '../../../lib/store/index';
import { MyStocksContent } from '../../../lib/store/reporting/types';
import { isCallStatusPending, isCallStatusReady } from '../../../lib/util/error-handling/StatusByCallHelpers';

import { Preloader } from '../../../components/index';
import TableContainerView from '../../../components/TableView/tableContainer/TableContainerView';
import { TABLE_HEADERS_MY_ACCOUNT_MY_STOCKS } from '../../../components/WatchList/WatchList.constans';
import ErrorContent from '../ErrorContent/ErrorContent';

type OwnProps = {
  tableData: MyStocksContent[];
};

type Props = OwnProps & ReduxProps;

const MyStocksTable = ({
  tableData,
  accountStatusData,
  openPostionsPending,
  openPostionsFetched,
}: Props) => {
  const headerItems = TABLE_HEADERS_MY_ACCOUNT_MY_STOCKS.map((item: string) => <th key={item}>{item}</th>);
  const isRewindProcessing = accountStatusData.dailyResetProcessing;

  const emptyContentManager = () => {
    if (openPostionsPending) {
      return <Preloader style={{ transform: 'scale(0.50)' }} owner={'MyStocks'} />;
    }
    if ((openPostionsFetched && tableData.length === 0) || isRewindProcessing) {
      return <ErrorContent tabTitle={lang.commonMyAccountNoStocks()} />;
    }
    return null;
  };

  return (
    <>
      {tableData.length > 0 && !isRewindProcessing ? (
        <TableContainerView
          tableHeaders={headerItems}
          data={tableData}
          isMultipleDivOfRow
          isButtonsInRow
          companyLogos
          otherButtons={lang.commonMyAccountButtonMyStocks()}
        />
      ) : emptyContentManager()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  accountStatusData: state.closeout.accountStatusData,
  openPostionsPending: isCallStatusPending(ReportingCall.getOpenPositions, state.reporting.statusByCall),
  openPostionsFetched: isCallStatusReady(ReportingCall.getOpenPositions, state.reporting.statusByCall),
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(MyStocksTable);
